/**
 * RED MS Routes
 */
export const API_CONFIG_RED_MS      = '/v1/users';
export const RED_PAYMENT_METHODS    = '/payment-methods';
export const RED_REDEEM             = '/redeem';
export const RED_REDEMPTION_OPTIONS = '/redemption-options';
export const RED_REDEMPTION_STATUS  = '/redemption-status';
export const REDEEM_EMAIL_CODE_MS   = '/send-redemption-code';
export const REDEEM_VERIFY_CODE_MS  = '/redemption-code';
export const RED_USER_STATS         = '/stats';
